import { AxiosRequestConfig } from 'axios'
import { IResponseBase, Repository } from 'ecp/repositories/Repository'
import api from 'services/api'

class BackofficeRepository extends Repository {
  async updateAreas (
    backofficeId: string,
    body: { areas: Array<string> },
    config?: AxiosRequestConfig,
    isAdministrator?: boolean
  ) {
    const path = isAdministrator ? '/administrators' : this.path
    return Repository.handle(() =>
      this.api.patch(`${path}/${backofficeId}/areas`, body, config)
    )
  }

  async fetchBackOffices (config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.get(`${this.path}/list/proposal`, config)
    )
  }
}

export default new BackofficeRepository({ api, path: '/backoffices' })
